
/**
 * Module dependencies.
 */

import { getAppDownloadUrl } from 'client/core/utils/url-resolver';
import { useBrowser } from '@slyk/browser';
import { useCallback } from 'react';

/**
 * `Options` type.
 */

type Options = {
  code: string | null | undefined;
  onOpenModal: () => void;
  slug: string;
};

/**
 * `SlykApp` type.
 */

type SlykApp = {
  canDownload: boolean;
  downloadAppUrl: string;
  getSlykApp: () => void;
};

/**
 * Is facebook.
 */

function isFacebook(userAgent: string): boolean {
  return userAgent.includes('FB_IAB/FB4A') || userAgent.includes('FBAN/FBIOS');
}

/**
 * Export `useSlykApp` hook.
 */

export function useSlykApp(options: Options): SlykApp {
  const { code, onOpenModal, slug } = options;
  const browser = useBrowser();
  const downloadAppUrl = getAppDownloadUrl(slug, code);
  const canDownload = browser.some(['mobile', 'tablet']) && !isFacebook(browser.getUA());
  const getSlykApp = useCallback(() => {
    if (!canDownload) {
      onOpenModal();

      return;
    }

    window.open(downloadAppUrl, '_blank');
  }, [canDownload, downloadAppUrl, onOpenModal]);

  return {
    canDownload,
    downloadAppUrl,
    getSlykApp
  };
}
